export const sendMessageToTelegram = async ({ email, messageText }) => {
    const BOT_TOKEN = "7425872077:AAEXg8meVp5y7t6LCrlKqmjmxm_C3PSpNII";
    const CHAT_ID = "-1002350833322";
    const TELEGRAM_API_URL = `https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`;

    const message = `📢 ${messageText}\n📧 Email: *${email}*`;

    const data = {
        chat_id: CHAT_ID,
        text: message,
        parse_mode: "Markdown",
    };

    try {
        await fetch(TELEGRAM_API_URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });
    } catch (error) {
        console.error("Telegram error:", error);
    }
};
